import ApplicationController from "../application_controller"

class EmployeeRecordsFormController extends ApplicationController {
  connect() {
    $(this.element).change((e) => {
      $(this.element).trigger('submit.rails')
      $(this.element).find('select').replaceWith("<span class='loading'></span>")
    })
  }
}

export default EmployeeRecordsFormController
